// extracted by mini-css-extract-plugin
module.exports = {"root":"PoolTokensCell_root__iACbi","coinIcon":"PoolTokensCell_coinIcon__ZXreo"};